import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Apply dark theme before first paint to prevent flash
if (typeof document !== "undefined" && localStorage.getItem("theme") === "dark") {
  document.body.classList.add("dark-theme");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister existing service workers (cleanup for old users)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

reportWebVitals();
